import React from 'react';
import Card from '../../Card';

const GRADE_COLOR = { '初阶': '#d97706', '进阶': '#2563eb', '熟练': '#16a34a', '高阶': '#7c3aed' };
const GRADE_DESC = {
  '初阶': '正在起步，有很大提升空间',
  '进阶': '基础扎实，继续深化实践',
  '熟练': '能力突出，建议拓展应用场景',
  '高阶': '卓越水平，引领 AI 应用前沿',
};

export default function P1Overview({ report }) {
  const core = report?.core || {};
  const narr = report?.narrative_v2 || {};
  const grade = core.grade;
  const gradeColor = GRADE_COLOR[grade] || '#2563eb';

  const portraits = Array.isArray(narr.one_line_portrait) ? narr.one_line_portrait : [];
  const primaryPortrait = portraits[0] || '';
  const altPortraits = portraits.slice(1);
  const showPortraitFold = portraits.length > 1;

  const nextSteps = Array.isArray(narr.action_roadmap) ? narr.action_roadmap.slice(0, 3) : [];

  return (
    <div data-testid="report-page-p1">
      <Card style={{
        textAlign: 'center', padding: '40px 32px', marginBottom: 24,
        background: 'linear-gradient(135deg,#1a3a6b,#2d5aa0)', color: '#fff', border: 'none',
      }}>
        {narr.highlight && (
          <p style={{ fontSize: 13, opacity: 0.75, marginBottom: 12, letterSpacing: 1 }}>
            {narr.highlight}
          </p>
        )}
        <p style={{ fontSize: 13, letterSpacing: 2, opacity: 0.7, marginBottom: 8 }}>您的 AIQ 测评得分</p>
        <div style={{ fontSize: 72, fontWeight: 900, lineHeight: 1, marginBottom: 12 }}>
          {core.total_score ?? '—'}
        </div>
        {grade && (
          <div style={{
            display: 'inline-block', padding: '6px 20px', borderRadius: 24,
            background: gradeColor, fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: 12,
          }}>
            {grade}
          </div>
        )}
        {GRADE_DESC[grade] && (
          <p style={{ opacity: 0.75, fontSize: 14, marginBottom: 4 }}>
            {GRADE_DESC[grade]}
          </p>
        )}
        <p style={{ opacity: 0.6, fontSize: 13 }}>
          共作答 {core.answered_count ?? '—'}/{core.total_questions ?? '—'} 题
        </p>
      </Card>

      {primaryPortrait && (
        <Card style={{ padding: '24px 28px', marginBottom: 24, borderLeft: '4px solid var(--color-primary, #1a3a6b)' }}>
          <h3 style={{ fontSize: 13, fontWeight: 700, marginBottom: 10, color: 'var(--color-text-muted, #64748b)', letterSpacing: 1 }}>
            一句话画像
          </h3>
          <p style={{ fontSize: 16, lineHeight: 1.7, color: 'var(--color-text)', margin: 0 }}>
            {primaryPortrait}
          </p>
          {showPortraitFold && (
            <details data-testid="report-page-p1-portrait-fold" style={{ marginTop: 14 }}>
              <summary style={{ cursor: 'pointer', fontSize: 13, color: 'var(--color-primary, #1a3a6b)', userSelect: 'none' }}>
                换个视角看自己
              </summary>
              <ul style={{ margin: '10px 0 0 0', padding: '0 0 0 18px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                {altPortraits.map((p, i) => (
                  <li key={i} style={{ fontSize: 14, lineHeight: 1.7, color: 'var(--color-text-secondary)' }}>{p}</li>
                ))}
              </ul>
            </details>
          )}
        </Card>
      )}

      {nextSteps.length > 0 && (
        <Card style={{ padding: '24px 28px', marginBottom: 24 }} data-testid="report-page-p1-next-steps">
          <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 16 }}>接下来 3 步</h3>
          <ol style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
            {nextSteps.map((s, i) => (
              <li key={i} style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                <span style={{
                  width: 24, height: 24, borderRadius: '50%', flexShrink: 0,
                  background: 'var(--color-primary, #1a3a6b)', color: '#fff',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, fontWeight: 700,
                }}>{s.step ?? i + 1}</span>
                <div style={{ flex: 1 }}>
                  <p style={{ fontWeight: 600, fontSize: 14, margin: 0 }}>{s.title || '（待生成）'}</p>
                  {s.timeframe && (
                    <p style={{ fontSize: 12, color: 'var(--color-text-muted)', marginTop: 2 }}>{s.timeframe}</p>
                  )}
                </div>
              </li>
            ))}
          </ol>
        </Card>
      )}
    </div>
  );
}
